import React from 'react';
import { IdentityCircleIcon } from './identity-circle-icon';
import { TopicCardDivider, TopicCardTitle, TOPIC_CARD_ICON_1 } from './topic-card-shared';

import identityPersonImage from './identity-person.webp';

interface IdentityTopicCardProps {
  title: string;
  className?: string;
}

export const IdentityTopicCard: React.FC<IdentityTopicCardProps> = ({ title, className = '' }) => (
  <div
    className={`flex w-full min-w-0 flex-col items-center justify-center overflow-hidden rounded-xl bg-white px-2 pb-4 pt-3 sm:px-4 sm:pb-8 sm:pt-6 ${className}`}
  >
    <div className="mt-1 flex w-full flex-col items-center sm:mt-2">
      <div className="relative flex items-start justify-center">
        <div className="absolute left-1 top-3 h-[64px] w-[64px] shrink-0 sm:left-2 sm:top-4 sm:h-[95.636px] sm:w-[95.642px]">
          <IdentityCircleIcon fill={TOPIC_CARD_ICON_1} className="h-full w-full" />
        </div>
        <img
          src={identityPersonImage}
          alt=""
          className="relative top-0.5 z-10 ml-8 aspect-[120.302/148.13] w-[80px] shrink-0 object-cover object-center sm:ml-10 sm:w-[120.302px]"
        />
      </div>
      <TopicCardDivider />
    </div>
    <TopicCardTitle title={title} />
  </div>
);
